export class MachineMaintenance {
  public _id: string;
  public machine: any;
  public maintenance: any;
  public hours: number;
  public nethours: number;
  public oillevel: string;
  public pressureswitch: boolean;
  public filterelem: boolean;
  public seperator: boolean;
  public oilfilter: boolean;
  public airfilter: boolean;
  public vbelt: boolean;
  public deltap: string;
  public netp: string;
  public temperature: string;
  public amperage: string;
  public pressure: string;
  public mpv: string;
  public smallmaterials: string;
  public notes: string;
}



// WEBPACK FOOTER //
// ./src/app/models/machine.maintenance.model.ts